"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const input_dialog_1 = require("../input-dialog");
const moment = require("moment");
require("jqwidgets-scripts/jqwidgets/jqxdatetimeinput");
require("jqwidgets-scripts/jqwidgets/jqxcalendar");
class DateTimeDialog extends input_dialog_1.default {
    constructor(_dateTimeDialogConfig = {}) {
        super(_dateTimeDialogConfig);
        this._dateTimeDialogConfig = _dateTimeDialogConfig;
    }
    get bodySelector() {
        const selector = this._dateTimeDialogConfig.bodySelector || ".date-time-modal-body";
        return `${this.rootSelector} ${selector}`;
    }
    get inputSelector() {
        return "#datetimepicker";
    }
    setInputValue(value) {
        const date = moment(value).toDate();
        $(this.inputSelector).jqxDateTimeInput({ value: date, showCalendarButton: this._dateTimeDialogConfig.showDate, showTimeButton: this._dateTimeDialogConfig.showTime, formatString: this._dateTimeDialogConfig.dateTimeFormat, width: "250px" });
    }
    clearInputValue() {
        // nothing to do here        
    }
    getInputValue() {
        return $(this.inputSelector).jqxDateTimeInput().val();
    }
    focusInput() {
        // no focus because in focused input, the icon is not shown
        // this.dateInput.focus(); // focus the first input
    }
    selectInput() {
    }
    toString() {
        return "Date+Time Dialog";
    }
}
exports.default = DateTimeDialog;
